import {UserInput} from "../../http/protocol";
import {UseFormRegister, UseFormSetValue} from "react-hook-form/dist/types/form";
import {FieldErrors, FieldErrorsImpl} from "react-hook-form/dist/types/errors";
import {RegisterOptions} from "react-hook-form/dist/types/validator";
import {selectText} from "../../user/ui/utils";
import DOWN_ARROW from "../../assets/down_arrow.svg";
import {t} from "../../i18n";
import * as React from "react";
import {InputError} from "./InputError";
import {toOptionsArray} from "../user-utils";
import {useEffect} from "react";
import { Merge } from "react-hook-form";

export const UserDetailsSelectInput = (
        props: {
            input: UserInput,
            setValue: UseFormSetValue<any>,
            name: string,
            register: UseFormRegister<any>,
            errors: FieldErrors<any>,
            options: RegisterOptions,
            attributeOptions: string }) => {

    const {input, name, register, errors, options} = props;
    let hasError = false;
    if (name.startsWith("attributes.") && errors.attributes) {
        let attributeName = name.replaceAll("attributes.", "");
        const errorsAttributes = errors.attributes as keyof FieldErrors | Merge<FieldErrors, FieldErrorsImpl<any>>
        hasError = !!errorsAttributes[attributeName as any];
    } else {
        hasError = !!errors[name];
    }
    let opts = toOptionsArray(props.attributeOptions);

    const {nameText, invalidText, helpText} = selectText(name);

    return (
        <div className={"form-group " + (hasError ? "has-error" : "")}>
            {(nameText && nameText.length > 0) &&
            <label id={name} className={"forms-label"} htmlFor={name}>{nameText}</label>}
            <select className={"form-control"}  {...register(name, options)}
                    style={{backgroundImage: `url(${DOWN_ARROW})`}}>
                {opts.map(o => {
                    return <option value={o} key={o}>{t("forms." + name + "-opt." + o)}</option>
                })}
            </select>
            {helpText.length > 0 && !hasError && <span className="help-block">{helpText}</span>}
            {hasError && <InputError name={name} errors={errors} invalidText={invalidText}/>}
        </div>
    )
}